import { render, staticRenderFns } from "./TheAuthorisedAppBar.vue?vue&type=template&id=85d65ef2&"
import script from "./TheAuthorisedAppBar.vue?vue&type=script&lang=ts&"
export * from "./TheAuthorisedAppBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports